<template>
  <!-- 素材区组件 action  -->
  <div class="export" id="EXPORT-SWF">

    <div class="mask-export-1" v-if="mask_export_1">
      <div class="export-1">
        <div class="header">
          <div class="title">导出动画</div>
          <div class="close">
            <i class="el-icon-close" @click="handleExportClose()"></i>
          </div>
        </div>
        <div class="export-tabs">
          <div class="tab" :class="{active: exportTab==='video'}" @click="switchTab('video')">在线导出</div>
          <div class="tab" :class="{active: exportTab==='online'}" @click="switchTab('online')">工具导出</div>
        </div>
        <div class="info">
          <div class="pic">
            <img v-if="anim_thumb" :src="anim_thumb">
            <img v-if="!anim_thumb" src="./file.png">
          </div>
          <div class="info-text">
            <div class="title">{{anim_title}}</div>
            <div class="duration">时长:{{anim_duration}}</div>
            <el-checkbox-group v-model="subtitle_audio_status" @change="handleChangeSubtitleAudio" v-show="exportTab==='online'">
              <el-checkbox label="带字幕"></el-checkbox>
              <el-checkbox label="带声音"></el-checkbox>
            </el-checkbox-group>
            <el-checkbox-group v-model="local_media" v-show="exportTab==='video'">
              <el-checkbox label="带字幕"></el-checkbox>
              <el-checkbox label="带声音"></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <hr>
        <div class="local-options" v-show="exportTab==='video'">
          <div class="item resolution-item">
            <span>清晰度:</span>
            <el-radio-group v-model="local_resolution" :disabled="local_running" class="resolution-group">
              <div class="resolution-row">
                <el-radio :label="1" v-if="this.vipLevel >= 100">去水印720p<span class="tip-1">(<span style="text-decoration: line-through;">10点/分钟</span>)</span></el-radio>
                <el-radio :label="2" v-if="this.vipLevel >= 100">去水印1080p<span class="tip-1">(<span style="text-decoration: line-through;">20点/分钟</span>)</span></el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="item">
            <span>格式:</span>
            <el-radio-group v-model="local_format" :disabled="local_running">
              <el-radio label="mp4">MP4</el-radio>
              <el-radio label="webm">WebM</el-radio>
            </el-radio-group>
            <span class="tip" v-if="!webcodecs_supported">{{webcodecs_tip}}</span>
          </div>
        </div>
        <div class="local-progress" v-if="local_running">
          <el-progress :percentage="local_progress_pct"></el-progress>
          <div class="tip">{{local_phase_text}}</div>
        </div>
        <div class="charging" v-show="exportTab==='online'">
          <div class="item">
            <span>计费时长:{{pay_duration}}分钟</span>
            <span class="tip">(不足一分钟，根据一分钟收费)</span>
          </div>
          <div class="item resolution-item">
            <span>清晰度:</span>
            <el-radio-group v-model="pixel_watermark_status" @change="handleChangePixelWatermark" class="resolution-group">
              <div class="resolution-row">
                <el-radio :label="1" v-if="this.vipLevel >= 100">去水印720p<span class="tip-1">(<span style="text-decoration: line-through;">10点/分钟</span>)</span></el-radio>
                <el-radio :label="2" v-if="this.vipLevel >= 100">去水印1080p<span class="tip-1">(<span style="text-decoration: line-through;">20点/分钟</span>)</span></el-radio>
              </div>
              <div class="resolution-row" v-if="this.vipLevel >= 200">
                <el-radio :label="3">去水印2k<span class="tip-1">(<span style="text-decoration: line-through;">50点/分钟</span>)</span></el-radio>
                <el-radio :label="4">去水印4k<span class="tip-1">(<span>100点/分钟</span>)</span></el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="item">导出点数：{{total_coin}}点</div>
        </div>
        <hr v-show="exportTab==='online'">
        <div class="pay" v-show="exportTab==='online'">
          <div class="item" v-if="total_coin != 0">
            <span>点数抵用: {{export_money}} </span>
            <span class="tip">(点数余额:{{export_coupon}})</span>
          </div>
          <div class="item money" v-if="fina_pay != 0">待支付:<span class="text">{{fina_pay}}点</span></div>
          <el-button type="warning" size="mini" class="user_recharge" v-if="fina_pay != 0" @click="handleRecharge(true)">充值</el-button>
        </div>
        <!-- <div class="agreement">
            <el-checkbox v-model="checked" @change="handleChecked"></el-checkbox>
            <span class="tip" @click="handleExportRule()">阅读并同意<a style="color:#3e87d3;">《专业版导出规则》</a></span>
        </div> -->
        <div class="footer">
          <div class="left" v-show="exportTab==='online'" @click="handleExportToolDownload()">下载导出工具V{{export_tool_version}}(windows版)</div>
          <div class="left" v-show="exportTab!=='online' && local_running" @click="cancelLocalExport()">取消</div>

          <div class="right">
            <el-button v-show="exportTab==='online'" type="warning" :disabled="submit_status" @click="handleSubmit()">提交</el-button>
            <el-button v-show="exportTab==='video'" type="warning" :disabled="local_running || !webcodecs_supported" @click="startVideoExport()">导出视频</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="mask-export-code" v-if="mask_export_code">
      <div class="export-2" >
        <div class="header">
          <div class="title">提取码</div>
          <div class="close">
            <i class="el-icon-close" @click="handleExportClose()"></i>
          </div>
        </div>
        <div class="export_code_tips" v-if="export_code_tips_status">复制成功</div>
        <div class="text code">提取码: {{export_code}}</div>

        <div class="text">(20分钟有效，请复制提取码，在导出工具中使用导出)</div>
        <div class="btn" style="text-align:center;">
          <el-button id="copy_btn" type="warning" data-clipboard-action="copy"
            data-clipboard-target="#clipboard" @click="handleCopyCode()">复制提取码</el-button>
        </div>
        <div class="download" @click="handleExportToolDownload()">
           下载导出工具V{{export_tool_version}}(windows版)
        </div>
      </div>
    </div>
    <!-- 充值组件 -->
    <Recharge :visible.sync="pay_money_status"></Recharge>

    <div class="clipboard" style="text-indent:-9999px;" id="clipboard"></div>

  </div>
</template>
<script>
  // 通讯协议
  import Protocol from '@/common/scripts/protocol.js'
  // 工具类
  import EUY from '@/common/scripts/euy.js'

  import Clipboard from 'clipboard'
  // 充值组件
  import Recharge from '@/components/Recharge/Recharge'
  // 浏览器导出runner（iframe隔离+WebCodecs）
  import exportRunner from '@/common/scripts/exportRunner.js'

  export default {
     // 组件
    components: {
      Recharge
    },
     // 数据
    data () {
      return {
        // -------------------------------------------------- [ FLASH ] --------------------------------------------------
        platform: this.$route.query.platform,
        dialog_export_visible: true,
        checkList: ['带字幕', '带声音'],

        // 声音字幕--状态
        subtitle_audio_status: ['带字幕', '带声音'],
        subtitle_status: 1,
        audio_status: 1,

        // 动画详情相关数据
        anim_title: '',
        anim_duration: '',
        anim_thumb: '',
        anim_id: '',
        //团队id
        team_id: '',
        // 分辨率单选 1:720p 2:1080p 3:2k
        pixel_watermark_status: 1,
        //分辨率  720、1080、2k
        pixel: 720,
        //分辨率水印 0:无水印 1:带水印
        watermark_status: 0,
        // 用户会员等级 0:个人版 100:标准版会员 200:专业版会员 1000:企业版会员
        vipLevel: 0,
        checked: true,
        // token
        has_token: '',
        // 总的费用
        total_coin: 0,
        // 计费时长
        pay_duration: '',
        // 个人账户
        export_coupon: 0,
        // 最终支付
        fina_pay: 0,
        // 支付列表
        recharge_list: [],
        // 已选支付项
        recharge_chose: '',
        // 充值提示
        charge_tip: '',
        // 选择充值方式
        pay_chosed: true,
        payStatus: true,
        pay_money_status: false,
        mask_export_tips_status: false,
        goods_id: '',
        order_id: '',
        mask_export_tip1: false,
        mask_export_code: false,
        export_code: '',
        export_money: '',
        pay_type_: '',
        submit_status: false,
        mask_export_1: false,
        export_tool_version: '',
        export_tool_url: '',
        export_code_tips_status: false,

        // -------------------------------------------------- [ 本地导出 ] --------------------------------------------------
        // 当前tab: video=视频导出 image=页面图片 online=在线导出
        exportTab: 'video',
        // 清晰度 0:标清854 1:高清1280 2:超清1920
        local_resolution: 1,
        // 视频格式 mp4|webm
        local_format: 'mp4',
        // 视频tab媒体项
        local_media: ['带字幕', '带声音'],
        // 导出运行态
        local_running: false,
        local_progress_pct: 0,
        local_phase_text: '',
        webcodecs_supported: false,
        webcodecs_tip: '当前浏览器不支持WebCodecs，请使用Chrome/Edge最新版'
      }
    },

    computed: {},

    watch: {},

    methods: {

      // 清晰度-水印修改
      handleChangePixelWatermark (val) {

        // 720带水印
        if(this.pixel_watermark_status == 1){

          this.pixel = '720'
          this.watermark_status = 0
        }

        // 1080无水印
        if(this.pixel_watermark_status == 2){

          this.pixel = '1080'
          this.watermark_status = 0
        }

        //2k无水印
        if(this.pixel_watermark_status == 3){
          this.pixel = '2000'
          this.watermark_status = 0
        }

        //4k无水印
        if(this.pixel_watermark_status == 4){
          this.pixel = '4000'
          this.watermark_status = 0
        }

        this.handleGetCalculate(this.anim_id, this.pixel, this.watermark_status)
      },

      // 字幕-声音修改
      handleChangeSubtitleAudio (val){

        // 都不带
        if(val.length == 0){
          this.subtitle_status = 0
          this.audio_status = 0
        }

        // 带一个
        if(val.length == 1){

          if(val[0] == '带声音'){
            this.subtitle_status = 0
            this.audio_status = 1
          }

          if(val[0] == '带字幕'){
            this.subtitle_status = 1
            this.audio_status = 0
          }
        }

        // 都带
        if(val.length == 2){
          this.subtitle_status = 1
          this.audio_status = 1
        }
      },

      // 显示/关闭充值组件
      handleRecharge(val){
          this.pay_money_status = val
      },
      // 提交订单
      handleSubmit () {
        if(this.total_coin == 0){
          this.handleGetExportCode (this.anim_id, this.pixel, this.watermark_status, this.subtitle_status, this.audio_status)
        }else{
          if(this.fina_pay == 0){
            this.handlePostCreateOrder (this.anim_id, this.pixel, this.watermark_status, this.subtitle_status, this.audio_status, this.total_coin, 1)
          }else{
            this.$message({
              message: '点数不足，请充值',
              type: 'error'
            })
          }
        }
      },

      // 导出规则
      handleExportRule () {
        window.open('http://pro.eeeuy.com/export_rule.html')
      },

      // 导出规则状态
      handleChecked () {

        if(this.checked){

          this.submit_status = false
        }else{
          this.submit_status = true
        }

      },

      // 复制提取码
      handleCopyCode () {

        var clipboard = new Clipboard('#copy_btn')

        document.getElementById('clipboard').innerHTML = this.export_code

        this.export_code_tips_status = true

        setTimeout(() => {

          this.export_code_tips_status = false

        }, 3000)

      },

      // ----------------------------------[ 本地导出 ]----------------------------------
      // 切换tab
      switchTab (tab) {
        this.exportTab = tab
      },

      // 素材像素档：分辨率->!at*x档位
      localPixel () {
        return [600, 900, 1200][this.local_resolution]
      },
      localOutWidth () {
        return [854, 1280, 1920][this.local_resolution]
      },

      // 找到当前编辑中的movie编辑器（EuCoreFactory.instances私有Map运行时可达）
      findMovieEditor () {
        try {
          const F = window.EuCore && window.EuCore.EuCoreFactory
          if (!F || !F.instances) return null
          for (const item of F.instances.values()) {
            const ed = item.instance && (item.instance.movieEditor || item.instance.editor || item.instance)
            if (ed && ed.movieData && typeof ed.selectedStepIndex === 'number') return ed
          }
        } catch (e) {}
        return null
      },

      // 编辑器活剧本（含未保存改动），仅在编辑器打开的正是本次导出动画时生效
      liveScript () {
        try {
          const ed = this.findMovieEditor()
          if (ed && ed.movieData && ed.movieData.id === this.anim_id
              && window.EuCore && window.EuCore.resource && window.EuCore.resource.MovieScriptEncodeManager) {
            return window.EuCore.resource.MovieScriptEncodeManager.encodeToString(ed.movieData)
          }
        } catch (e) {}
        return ''
      },

      // 组装runner初始化配置
      buildLocalConfig (subtitle) {
        return {
          movieId: this.anim_id,
          apiUrl: '',
          cdnUrl: window.EuCore ? EuCore.EuCoreEngine.getCDNUrl() : '',
          token: this.has_token,
          pixel: this.localPixel(),
          subtitle: subtitle,
          transparent: false,
          width: this.localOutWidth(),
          script: this.liveScript()
        }
      },

      onLocalProgress (phase, ratio) {
        const names = { init: '初始化', load: '加载素材', render: '渲染帧', encode: '编码封装', audio: '合成音频' }
        this.local_phase_text = names[phase] || phase
        // 各阶段占比：init/load占40%，render占55%，encode占5%
        if (phase === 'init' || phase === 'load') {
          this.local_progress_pct = Math.round(ratio * 40)
        } else if (phase === 'render') {
          this.local_progress_pct = 40 + Math.round(ratio * 55)
        } else {
          this.local_progress_pct = 95 + Math.round(ratio * 5)
        }
      },

      // 开始视频导出
      startVideoExport () {
        if (!this.webcodecs_supported) return
        this.local_running = true
        this.local_progress_pct = 0
        this.local_phase_text = '初始化'
        const withSubtitle = this.local_media.indexOf('带字幕') >= 0
        const withAudio = this.local_media.indexOf('带声音') >= 0
        const cfg = this.buildLocalConfig(withSubtitle)
        exportRunner.exportVideo(cfg, {
          format: this.local_format,
          fps: 24,
          audio: withAudio
        }, (phase, ratio) => {
          this.onLocalProgress(phase, ratio)
        }).then((res) => {
          this.local_running = false
          this.downloadBlob(res.blob, (this.anim_title || this.anim_id) + '.' + res.ext)
          this.$message({ message: '导出完成', type: 'success' })
        }).catch((err) => {
          this.local_running = false
          if (err.message !== 'cancelled') {
            this.$message({ message: err.message || '导出失败', type: 'error' })
          }
        })
      },

      // 取消本地导出
      cancelLocalExport () {
        exportRunner.cancel()
        this.local_running = false
        this.local_phase_text = ''
      },

      // 触发浏览器下载
      downloadBlob (blob, filename) {
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        setTimeout(() => { URL.revokeObjectURL(url); a.remove() }, 1000)
      },

      // 关闭导出框
      handleExportClose () {

        // 关闭时取消进行中的本地导出并释放runner
        if (this.local_running) exportRunner.cancel()
        exportRunner.destroy()
        this.local_running = false
        this.local_prepared = false

        this.handleRecharge(false)

        let platform = this.$route.query.platform

        let MToolBarChangeData  = new proto.com.proto.s.MUint32()

        let value = 524288

        MToolBarChangeData.setValue(value)

        // protobuf 序列化
        let protoBytes = MToolBarChangeData.serializeBinary()

        // Uint8Array 转换 Array
        let protoBytesArray = Array.from(protoBytes)

        let export_core_1_20 = {
          packageId: 0,
          senderId: TOOLBAR,
          senderName: TOOLBAR_NAME,
          receiverId: CORE,
          receiverName: CORE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 1,
          messageId: 20,
          protoBytesType: 'proto.com.proto.s.MUint32',
          protoBytes: protoBytesArray
        }

        // 发送消息
        Protocol.sender(platform, export_core_1_20)
      },

      // 下载导出插件
      handleExportToolDownload () {

        window.open(this.export_tool_url)
      },

      // ----------------------------------[ api ]-----------------------------------------
      // 获取动画详情
      handlePostAnimDetail () {
        let URL = process.env.HOST + '/pro/api/matter/listByIds'

        let params = 'id=' + this.anim_id
        let headers = {
          'token': this.has_token,
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
        this.AJAX.post(URL, headers, params).then((data)=>{
          console.log(data)

          this.anim_title = data.result[this.anim_id].title

          let time = data.result[this.anim_id].extdata.duration

          let minute = parseInt(parseInt(time)/60) >= 10 ? parseInt(parseInt(time)/60) : '0' + parseInt(parseInt(time)/60)
          let second = parseInt(time)%60 >= 10 ? parseInt(time)%60 : '0' + parseInt(time)%60

          this.anim_duration =  minute + '：' + second
          this.anim_thumb = data.result[this.anim_id].thumb

        }).catch((err)=>{
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },

      // 获取导出费用
      handleGetCalculate (data_id, pixel, watermark) {

        let URL = process.env.HOST + '/pro/api/order/fundInfo'
        let headers = {
          'token': this.has_token
        }
        let params = {
            'team_id': this.team_id
        }
        console.log("fundInfo:", params)
        this.AJAX.get(URL, headers, params).then((data)=>{
          this.export_coupon = data.result.export_coupon

          let URL = process.env.HOST + '/pro/api/export/calculate'
          let headers = {
            'token': this.has_token
          }
          let params = {
            'data_id': data_id,
            'pixel': pixel,
            'watermark': watermark,
            'team_id': this.team_id,
          }
          this.AJAX.get(URL, headers, params).then((data)=>{
            if(data.code == 0){
                this.mask_export_1 = true
                this.total_coin = data.result.total_coin
                this.pay_duration = data.result.valuation_duration/60
                if(this.total_coin == 0){
                  this.fina_pay = 0
                }
                //total_coin:导出费用,export_coupon:帐号剩余的导出卷
                //export_money:需要扣掉的导出卷,fina_pay:实际需要支付的金额
                
                if(this.total_coin > 0){
                  let money = this.total_coin - this.export_coupon
                  if(money > 0){
                    //剩余的导出卷不够用了
                    this.fina_pay = money
                    this.export_money = this.export_coupon
                  }else{
                    this.fina_pay = 0
                    this.export_money = this.total_coin
                  }
                }
                console.log("export_money:=", this.total_coin, this.export_coupon, this.export_money);
            }else {
              this.$message({
                message: data.msg,
                type: 'error'
              })
              this.handleExportClose()
            }
          }).catch((err)=>{
              this.$message({
                message: err.msg||err.message,
                type: 'error'
              })
              this.handleExportClose()
          })
        }).catch((err)=>{
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
            this.handleExportClose()
        })
      },

      // 获取当前用户余额
      handleGetFundInfo () {

        let URL = process.env.HOST + '/pro/api/order/fundInfo'
        let headers = {
          'token': this.has_token
        }
        let params = {
            'team_id': this.team_id
        }
        console.log("fundInfo:", params)
        this.AJAX.get(URL, headers, params).then((data)=>{
          this.export_coupon = data.result.export_coupon
        }).catch((err)=>{
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },

      // 获取用户会员权限
      handleGetIdentity() {
          let URL = process.env.HOST + '/pro/api/user/identity'
          let headers = {
            'token': this.has_token
          }
          let params = {
            'team_id': this.team_id
          }
          
          this.AJAX.get(URL, headers, params).then((response) => {
              let res = response.result
              // 0:个人版 100:标准版会员 200:专业版会员 1000:企业版会员
              this.vipLevel = res.viplevel
              let limitTime = res.limittime
          }).catch((err) => {
              this.$message({
                message: err.msg || '获取会员权限失败',
                type: 'error'
              })
          })
      },
      // 获取导出码
      handleGetExportCode (data_id, pixel, watermark, subtitle, audio) {
        let URL = process.env.HOST + '/pro/api/export/getCode'

        let params = {
          'data_id': data_id,
          'pixel': pixel,
          'watermark': watermark,
          'subtitle': subtitle,
          'audio': audio
        }
        let headers = {
          'token': this.has_token,
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
        this.AJAX.get(URL, headers, params).then((data)=>{
          // window.open(data.result.pay_ali_url)
          console.log(data)

          this.mask_export_1 = false

          this.mask_export_code = true

          this.export_code = data.result.code

        }).catch((err)=>{
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },
      // 创建导出订单
      handlePostCreateOrder (data_id, pixel, watermark, subtitle, audio, coupon, pay_type)
      {
          let URL = process.env.HOST + '/pro/api/export/createOrder'
          let params = 'data_id=' + data_id + '&pixel=' + pixel + '&watermark=' + watermark + '&subtitle=' + subtitle + '&audio=' + audio + '&coupon=' + coupon + '&pay_type=' +pay_type + '&team_id=' + this.team_id
          console.log("createOrder:", params)
          let headers = {
              'token': this.has_token,
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
          this.AJAX.post(URL, headers, params).then((data)=>{
              if(data.result.order){
                  if(data.result.order.status == 2){
                      this.mask_export_1 = false
                      this.mask_export_code = true
                      this.export_code = data.result.export.code
                  }
                  if(data.result.order.status == 1){
                    this.$message({
                      message: '点数不足，请充值',
                      type: 'error'
                    })
                  }
              }else{
                  this.mask_export_1 = false
                  this.mask_export_code = true
                  this.export_code = data.result.export.code
              }
          }).catch((err)=>{
              this.$message({
                  message: err.msg||err.message,
                  type: 'error'
              })
          })
      },
      // 获取导出插件数据
      handleGetExportTool () {
        let URL = process.env.HOST + '/pro/api/export/getConfig'
        let params = {
        }
        let headers = {
          'token': '',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
        this.AJAX.get(URL, headers, params).then((data)=>{
          this.export_tool_version = data.result.ver
          this.export_tool_url = data.result.window
        }).catch((err)=>{
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },
    },
    
    // 渲染
    mounted () {
      this.handleGetExportTool()
      this.webcodecs_supported = exportRunner.isSupported()
      //WebCodecs仅在安全上下文(https或localhost)暴露：http+自定义域名下所有浏览器都没有VideoEncoder，
      //此时提示语应与"浏览器太旧"区分开，避免误导用户去升级浏览器
      if (!this.webcodecs_supported && window.isSecureContext === false) {
        this.webcodecs_tip = '当前页面为非安全连接(http)，浏览器未启用视频编码能力'
      }
      let width = document.body.clientWidth
      let height = document.body.clientHeight
      $('.mask-export-1').css({
        width: width + 'px',
        height: height + 'px'
      })
      $('.mask-export2').css({
        width: width + 'px',
        height: height + 'px'
      })
      $('.mask-export-tips').css({
        width: width + 'px',
        height: height + 'px'
      })
      $('.mask-export-tip1').css({
        width: width + 'px',
        height: height + 'px'
      })
      let platform = this.$route.query.platform
      let _this = this
      // 模块初始化
      Protocol.onSocketInit(platform, EXPORT_NAME, EXPORT)

      // 模块与服务器建立链接
      Protocol.onSocketConnect(platform, EXPORT_NAME)
      // 模块与服务器建立链接
      Protocol.onSocketRegister(platform, EXPORT_NAME, EXPORT)
      // 接收消息
      Protocol.receiver(platform, EXPORT_NAME)

      window[EXPORT_NAME].domReady = () => {

        //请求Token
        let export_core_1_1 = {
          packageId: 0,
          senderId: EXPORT,
          senderName: EXPORT_NAME,
          receiverId: CORE,
          receiverName: CORE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 1,
          messageId: 1,
          protoBytesType: 'proto.com.proto.s.MToken',
          protoBytes: []
        }

        // 发送消息
        Protocol.sender(platform, export_core_1_1)

        // 请求当前tab数据
        let export_core_1_11 = {
          packageId: 0,
          senderId: EXPORT,
          senderName: EXPORT_NAME,
          receiverId: CORE,
          receiverName: CORE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 1,
          messageId: 11,
          protoBytesType: '',
          protoBytes: []
        }
        // 发送消息
        Protocol.sender(platform, export_core_1_11)
      }

      window[EXPORT_NAME].message = (senderId, packageId, sessionId, messageId, protoBytes) => {
          if (sessionId == 1 && messageId == 12) {
              let tabdata = Protocol.deserializeBinary('proto.com.proto.s.MTabData', protoBytes).toObject()
              console.log(tabdata)
              _this.anim_id = tabdata.id
              _this.team_id = tabdata.teamid
          }else if(sessionId == 1 && messageId == 2) { // 同步token
              let is_token = Protocol.deserializeBinary('proto.com.proto.s.MToken', protoBytes).array
              _this.has_token = is_token[0]
              setTimeout(() => {
                  // 初始化动画详情
                  _this.handlePostAnimDetail()
                  // 初始化会员权限
                  _this.handleGetIdentity()
                  // 初始化导出费用
                  _this.handleGetCalculate(_this.anim_id, _this.pixel, _this.watermark_status)
              },50)
          }
      }
    }
  }
</script>

<style lang="stylus">
  .mask-export-1
    width 100%
    height 100%
    background rgba(255,255,255,0.4)
    position absolute
    top 0
    left 0
    z-index 10
    .export-1
      width 730px
      margin 0 auto
      background #fff
      margin-top 10%
      box-shadow: 0 1px 3px rgba(0,0,0,.3)
      .header
        height 35px
        line-height 35px
        position relative
        background #d8d8d8
        padding 0 16px
        .title
          text-align center
          font-weight bold
          font-size 18px
        .close
          position absolute
          top 0
          right 16px
          height 35px
          line-height 35px
          .el-icon-close
            color #a5a5a5
            cursor pointer
      .export-tabs
        display flex
        padding 0 16px
        margin-top 12px
        border-bottom 1px solid #e4e4e4
        .tab
          padding 6px 18px
          font-size 14px
          color #666
          cursor pointer
          border-bottom 2px solid transparent
          &:hover
            color #333
          &.active
            color #ff4f57
            border-bottom-color #ff4f57
            font-weight bold
      .info
        margin-top 16px
        position relative
        padding-left 132px
        padding-right 16px
        .pic
          position absolute
          top 0
          left 16px
          height 67px
          width 100px
          img
            height 67px
            width 100px
            display block
        .info-text
          .title
            font-size 14px
            font-weight bold
            padding-top 5px
            height 16px
            line-height 16px
          .duration
            margin 4px 0
            font-size 12px
            height 16px
            line-height 16px
      hr
        margin 0 16px
        color #d1d1d1
        margin-top 16px
      .charging
        padding 0 16px
        margin-top 8px
        .item
          height  20px
          line-height 20px
          font-size 14px
          color #000
          margin-top 10px
          .tip
            color #838383
          .tip-1
            color #ff4f57
        .resolution-item
          height auto
          .resolution-group
            display flex
            flex-direction column
            gap 8px
            .resolution-row
              display flex
              gap 20px
              .el-radio
                margin-right 0
      .local-options
        padding 0 16px
        margin-top 16px
        .item
          min-height 28px
          line-height 28px
          font-size 14px
          color #000
          margin-top 8px
          display flex
          align-items center
          gap 8px
          .tip
            color #838383
            font-size 12px
          .tip-1
            color #ff4f57
      .local-progress
        padding 0 16px
        margin-top 16px
        .tip
          color #838383
          font-size 12px
          margin-top 4px
          text-align center
      .pay
        padding 0 16px
        margin-top 16px
        display flex
        align-items center
        gap 10px
        .item
          height  20px
          line-height 20px
          font-size 14px
          color #000
          margin-top 10px
          .tip
            color #838383
          .tip-1
            color #ff4f57
            cursor pointer
        .money
          font-weight bold
          display flex
          align-items center
          gap 10px
          .text
            color #ff4f57
        .user_recharge
          margin-top 10px
      .agreement
          margin-top  35px
          margin-left 16px
      .footer
        height 48px
        line-height 48px
        background #f0f0f0
        position relative
        margin-top 15px
        font-size 12px
        .left
          position absolute
          top 0
          left 16px
          height 48px
          line-height 48px
          text-decoration underline
          color #3e87d3
          cursor pointer
        .center
          text-align center
          height 48px
          line-height 48px
          font-size 12px
          .tip
            height 48px
            line-height 48px
            text-decoration underline
            color #3e87d3
            cursor pointer
        .right
          position absolute
          top 2px
          right 16px
  .mask-export2
    width 100%
    height 100%
    background rgba(255,255,255,0.4)
    position absolute
    top 0
    left 0
    z-index 10
    .export-2
      width 400px
      margin 0 auto
      background #fff
      margin-top 10%
      box-shadow: 0 1px 3px rgba(0,0,0,.3)
      position absolute
      top 10%
      left 50%
      margin-left -200px
      z-index 1000
      .header
        position relative
        padding 16px
        .title
          text-align center
          font-weight bold
          font-size 18px
          height 35px
          line-height 35px
        .close
          position absolute
          top 0
          right 16px
          height 35px
          line-height 35px
          .el-icon-close
            color #a5a5a5
            cursor pointer
        .tips
          font-size 12px
          color #838383
          text-align center
          margin 10px 0
        .charge_tip
          margin-top 10px
          color #ff4f57
          margin-bottom 20px
      .footer
        margin-top 20px
        .title
          height 30px
          line-height 30px
          text-align center
        .pay_list
          overflow hidden
          padding 20px
          .item
            padding 10px
            height 20px
            line-height 20px
            float left
            border 1px solid #666
            cursor pointer
          .active
            border 1px solid #ff4f57
      .pay_btn
        text-align center
        margin-top 20px
        padding-bottom 20px
  .mask-export-tips
    width 100%
    height 100%
    background rgba(255,255,255,0.4)
    position absolute
    top 0
    left 0
    z-index 10
    .export-tips
      width 730px
      margin 0 auto
      background #fff
      box-shadow: 0 1px 3px rgba(0,0,0,.3)
      margin-top 10%
      z-index 1000
      .header
        height 35px
        line-height 35px
        position relative
        background #d8d8d8
        padding 0 16px
        .title
          text-align center
          font-weight bold
          font-size 18px
        .close
          position absolute
          top 0
          right 16px
          height 35px
          line-height 35px
          .el-icon-close
            color #a5a5a5
            cursor pointer
      .title
        margin-top 70px
        text-align center
        font-size 14px
        padding-bottom 30px
      .text
        margin-top 15px
        text-align center
        font-size 12px
      .btn_list
        margin-top 45px
        padding-bottom 149px
        text-align center
  .mask-export-tip1
    width 100%
    height 100%
    background rgba(255,255,255,0.4)
    position absolute
    top 0
    left 0
    z-index 11
    .export-2
      width 400px
      margin 0 auto
      background #fff
      margin-top 10%
      box-shadow: 0 1px 3px rgba(0,0,0,.3)
      position absolute
      top 10%
      left 50%
      margin-left -200px
      z-index 1000
      .header
        position relative
        background #d8d8d8
        .title
          text-align center
          font-weight bold
          font-size 18px
          height 35px
          line-height 35px
        .close
          position absolute
          top 0
          right 16px
          height 35px
          line-height 35px
          .el-icon-close
            color #a5a5a5
            cursor pointer
      .text
        text-align center
        margin-top 30px
        padding-bottom 30px
      .btn
        text-align center
        padding-bottom 30px
  .mask-export-code
    width 100%
    height 100%
    background rgba(255,255,255,0.4)
    position absolute
    top 0
    left 0
    z-index 11
    .export-2
      width 400px
      margin 0 auto
      background #fff
      margin-top 10%
      box-shadow: 0 1px 3px rgba(0,0,0,.3)
      position absolute
      top 10%
      left 50%
      margin-left -200px
      z-index 1000
      .export_code_tips
        padding-top: 20px
        font-size 16px
        color green
        text-align center
      .header
        position relative
        background #d8d8d8
        .title
          text-align center
          font-weight bold
          font-size 18px
          height 35px
          line-height 35px
        .close
          position absolute
          top 0
          right 16px
          height 35px
          line-height 35px
          .el-icon-close
            color #a5a5a5
            cursor pointer
      .text
        margin-top 8px
        padding-bottom 10px
        text-align center
      .code
        margin-top 20px
        font-size 16px
        font-weight bold
      .download
        margin-top 16px
        padding-bottom 20px
        text-align center
        text-decoration underline
        color #3e87d3
        cursor pointer






</style>



// WEBPACK FOOTER //
// Export.vue?36ad2591